import React, { useMemo } from 'react';
import { IntegrationTermsAndConditions } from '../services/api/types';
import StepInput from './StepInput';
import { P2GLink } from '@parcel2go/peacock-legacy-core/dist/link';
import { P2GText } from '@parcel2go/peacock-legacy-core/dist/typography';

interface props {
  terms: IntegrationTermsAndConditions;
  value: string;
  disabled: boolean;
  onUpdate: (key: string, value: string) => void;
}

const TermsLabel: React.FC<props> = (props) => {
  const label = useMemo(() => {
    // Not sure theres a better way to do this at the moment.
    if (props.terms.input.placeholder === "By clicking 'Link Account', you agree to our Terms and Conditions.") {
      return (
        <P2GText variant="body2">
          By clicking 'Link Account', you agree to our{' '}
          <P2GLink href={props.terms.url} target="_blank">
            Terms and Conditions
          </P2GLink>
          .
        </P2GText>
      );
    }

    return (
      <P2GText variant="body2">
        {props.terms.input.placeholder}{' '}
        <P2GLink href={props.terms.url} target="_blank">
          View Here
        </P2GLink>
      </P2GText>
    );
  }, [props.terms]);

  return (
    <StepInput
      disabled={props.disabled}
      input={props.terms.input}
      value={props.value}
      onUpdate={props.onUpdate}
      label={label}
    />
  );
};
export default TermsLabel;
